import React from 'react'
import injectStyles from 'react-jss'

import LoadingIndicator from '../../../../Components/LoadingIndicator/LoadingIndicator'
import { styles } from '../styles'

const SingleChatView = ({
  setRef,
  onlyRead,
  classes,
  height = 'calc(80vh - 126px)',
}) => {
  return (
    <div className={classes.root}>
      <div style={{ height }} ref={c => setRef(c)}>
        <LoadingIndicator />
      </div>
      {onlyRead ? <div className={classes.hide} /> : null}
    </div>
  )
}

export default injectStyles(styles)(SingleChatView)
